var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            [
              _c("b-loading", {
                attrs: { active: _vm.isLoading, "is-full-page": "" },
                on: {
                  "update:active": function ($event) {
                    _vm.isLoading = $event
                  },
                },
              }),
            ],
            1
          )
        : _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { staticClass: "languageSwitcher" },
              [_c("language-switcher")],
              1
            ),
            !_vm.errorMessage
              ? _c("div", { staticClass: "container is-fluid" }, [
                  _c(
                    "div",
                    { staticClass: "columns hero is-primary is-centered" },
                    [
                      _c("div", { staticClass: "column section" }, [
                        _c(
                          "h1",
                          {
                            staticClass:
                              "title is-2 is-primary has-text-centered",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "consignee.consignee_declaration.welcome"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "card has-text-centered mt-3" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "card-content",
                                staticStyle: { "white-space": "pre-line" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("closure_form.explainer_text")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  !_vm.submited
                    ? _c("div", [
                        !_vm.closure.notClosing
                          ? _c("div", [
                              _c("div", { staticClass: "column is-full" }, [
                                _c(
                                  "div",
                                  { staticClass: "card has-text-centered" },
                                  [
                                    _c("div", { staticClass: "card-header" }, [
                                      _c(
                                        "span",
                                        { staticClass: "card-header-title" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "closure_form.start_date"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "card-content" },
                                      [
                                        _c(
                                          "b-field",
                                          [
                                            _c("b-datepicker", {
                                              attrs: {
                                                name: "startdate",
                                                icon: "calendar-alt",
                                                placeholder: "Start date",
                                                "date-formatter": (date) =>
                                                  _vm
                                                    .$dayjs(date)
                                                    .format("DD/MM/YYYY"),
                                              },
                                              model: {
                                                value: _vm.closure.startDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.closure,
                                                    "startDate",
                                                    $$v
                                                  )
                                                },
                                                expression: "closure.startDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "column is-full" }, [
                                _c(
                                  "div",
                                  { staticClass: "card has-text-centered" },
                                  [
                                    _c("div", { staticClass: "card-header" }, [
                                      _c(
                                        "span",
                                        { staticClass: "card-header-title" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("closure_form.end_date")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "card-content" },
                                      [
                                        _c(
                                          "b-field",
                                          [
                                            _c("b-datepicker", {
                                              attrs: {
                                                name: "enddate",
                                                icon: "calendar-alt",
                                                placeholder: "End date",
                                                "date-formatter": (date) =>
                                                  _vm
                                                    .$dayjs(date)
                                                    .format("DD/MM/YYYY"),
                                              },
                                              model: {
                                                value: _vm.closure.endDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.closure,
                                                    "endDate",
                                                    $$v
                                                  )
                                                },
                                                expression: "closure.endDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "column is-full" }, [
                          _c("div", { staticClass: "card has-text-centered" }, [
                            _c("div", { staticClass: "card-header" }, [
                              _c("span", { staticClass: "card-header-title" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("closure_form.not_closing")) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "card-content" },
                              [
                                _c(
                                  "b-field",
                                  [
                                    _c("b-checkbox", {
                                      attrs: { name: "notClosed" },
                                      model: {
                                        value: _vm.closure.notClosing,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.closure,
                                            "notClosing",
                                            $$v
                                          )
                                        },
                                        expression: "closure.notClosing",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        !_vm.closure.notClosing
                          ? _c("div", { staticClass: "column is-full" }, [
                              _c(
                                "div",
                                { staticClass: "card has-text-centered" },
                                [
                                  _c("div", { staticClass: "card-header" }, [
                                    _c(
                                      "span",
                                      { staticClass: "card-header-title" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("closure_form.comments")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "card-content" },
                                    [
                                      _c(
                                        "b-field",
                                        [
                                          _c("b-input", {
                                            attrs: { type: "textarea" },
                                            model: {
                                              value: _vm.closure.comment,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.closure,
                                                  "comment",
                                                  $$v
                                                )
                                              },
                                              expression: "closure.comment",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "column has-text-centered is-full" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "button is-primary",
                                on: { click: _vm.submit },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "consignee.consignee_declaration.submit"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm.submited
                    ? _c("div", [
                        _c("div", { staticClass: "column is-full" }, [
                          _c("div", { staticClass: "card has-text-centered" }, [
                            _c("div", { staticClass: "card-header" }, [
                              _c("span", { staticClass: "card-header-title" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("closure_form.new_closure")) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "card-content" },
                              [
                                _c("b-field", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button is-primary",
                                      on: { click: _vm.newSubmission },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "closure_form.new_closure_button"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }